import http from '@util/http';
import { finance } from '@api/req';

/**
 * 借款
 */
export async function queryLoanList(params) {
  return http.get(finance.GET_LOAN_LIST, params);
}

export async function queryLoanMyList(params) {
  return http.get(finance.GET_LOAN_MY, params);
}

export async function queryMyLoanCheckList(params) {
  return http.get(finance.GET_LOAN_CHECK, params);
}

export async function queryLoanOrgStatic(params) {
  return http.get(finance.GET_LOAN_STATIC_ORG, params);
}

export async function queryLoanIncubatorStatic(params) {
  return http.get(finance.GET_LOAN_STATIC_INCUBATOR, params);
}

export async function queryLoanOrgRecord(params) {
  return http.get(finance.GET_LOAN_RECORD_ORG, params);
}

export async function queryLoanInfo(params) {
  return http.get(finance.GET_LOAN_INFO, params);
}

export async function querySaveLoan(params) {
  return http.post(finance.LOAN_SAVE, params);
}

export async function queryDeleteLoan(params) {
  return http.get(finance.LOAN_DELETE, params);
}

export async function queryNextLoan(params) {
  return http.get(finance.LOAN_NEXT, params);
}

export async function queryReturnLoan(params) {
  return http.post(finance.LOAN_RETURN, params);
}

export async function queryCallbackLoan(params) {
  return http.get(finance.LOAN_CALLBACK, params);
}

export async function queryLoanWorkflow(params) {
  return http.get(finance.LOAN_WORKFLOW, params);
}

export async function queryLoanWriteInfo(params) {
  return http.get(finance.GET_LOAN_WRITE_INFO, params);
}

export async function querySaveWriteLoan(params) {
  return http.post(finance.LOAN_WRITE_SAVE, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/loan.js